import { groupItem } from './groupItem';
import { tableImportMapping } from './importModels';
import { schedulingItem } from './schedulingItem';
import { importConfig } from './tableConfigs';

export class schedulerItemViewModel
{
	/**
	 *
	 */
	constructor() {
		this.itemID = 0;
		this.name = "";
		this.fromDate = null;
		this.toDate = null;
		this.isActive = false;
		this.continueIfError = false;

		this.scheduling = new schedulingItem();
		this.groups = [];
		this.importMappings = [];
	}
	itemID: number;
	name: string;
	azioniPreElaborazione: string;
	azioniPostElaborazione: string;
	fromDate: Date | string | null;
	toDate: Date | string | null;
	dataCreazione: Date | string;
	dataModifica: Date | string;
	isActive: boolean;
	onDemand: boolean;
	cancellata: boolean;
	continueIfError: boolean;


	scheduling: schedulingItem;

	groups: groupItem[];
	importMappings: importConfig[];
}